import api from './index'
import { axios } from '@/utils/request'

// 数据管理

export function getAssignDataList (parameter) {
  return axios({
    url: api.AssignDataList,
    method: 'get',
    params: parameter
  })
}

export function getUserStatisticsList (parameter) {
  return axios({
    url: api.UserStatisticsList,
    method: 'get',
    params: parameter
  })
}

export function assignTask (params) {
  return axios({
    url: api.AssignTask,
    method: 'post',
    params: params
  })
}

export function getTaskUserList (params) {
  return axios({
    url: api.TaskUserList,
    method: 'get',
    params: params
  })
}

export function editTaskData (params) {
  return axios({
    url: api.EditTaskData,
    method: 'put',
    params: params
  })
}

export function deleteTaskData (data_id) {
  return axios({
    url: api.DeleteTaskData + '/' + data_id,
    method: 'delete'
  })
}

// 数据采集
export function addFile (params) {
  return axios({
    url: api.AddFile,
    method: 'post',
    params: params
  })
}

export function addData (params) {
  return axios({
    url: api.AddData,
    method: 'post',
    params: params
  })
}

export function getDataList (parameter) {
  return axios({
    url: api.DataList,
    method: 'get',
    params: parameter
  })
}

export function editData (params) {
  return axios({
    url: api.EditData,
    method: 'put',
    params: params
  })
}

export function deleteData (data_id) {
  return axios({
    url: api.DeleteData + '/' + data_id,
    method: 'delete'
  })
}
export function getManagerDataStatistics (params) {
  return axios({
    url: api.ManagerDataStatistics,
    method: 'get',
    params: params
  })
}
